<template>
  <div id="js-editor">
  </div>
</template>

<script>
export default {

}
</script>

<style>
#js-editor {
  width: 100%;
  height: 100%;
}

.powered-by-firepad {
  display: none
}
</style>

